import { render } from "./Surfaces.vue?vue&type=template&id=1cee6a40&scoped=true"
import script from "./Surfaces.vue?vue&type=script&lang=js"
export * from "./Surfaces.vue?vue&type=script&lang=js"

import "./Surfaces.vue?vue&type=style&index=0&id=1cee6a40&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cee6a40"]])

export default __exports__